import type { DeviceAccess } from './deviceProbe'

/**
 * What a completed recovery attempt should raise on the MICROPHONE walkthrough —
 * and nothing else. Camera evidence (`camAccess`) is deliberately not a
 * parameter: a camera-only recovery (`send_stalled`/`frozen`/`track_ended`) must
 * never open the mic dialog, which is what happened when `unverified` camera
 * evidence fell through to `onFault` and rendered as `mic.help.titleBlocked`.
 */
export function micWalkthroughFault(micAccess: DeviceAccess | null): DeviceAccess | null {
  if (!micAccess || micAccess === 'ok') return null
  return micAccess
}
